/**
 * Animations Module
 * The idea here is track what is animating at any given time working together with the EventBus component to determine when animations finish and when to trigger new animations
 */
import EventBus from './event-bus'

export default {
  state: {
    mainNavigationAnimating: false,
    subNavigationAnimating: false,
    interactiveSlidesAnimating: false,
    tagsAnimating: false,
  },

  getters: {
    isAnimating: (state) => {
      return state.mainNavigationAnimating || state.subNavigationAnimating || state.interactiveSlidesAnimating || state.tagsAnimating
    }
  },

  mutations: {
    INTERACTIVE_SLIDES_ANIMATE_START (state) {
      console.log('animations.module: INTERACTIVE_SLIDES_ANIMATE_START')
      EventBus.$emit('INTERACTIVE_SLIDES_ANIMATE_START')
      state.interactiveSlidesAnimating = true
    },

    INTERACTIVE_SLIDES_ANIMATE_END (state) {
      console.log('animations.module: INTERACTIVE_SLIDES_ANIMATE_END')
      EventBus.$emit('INTERACTIVE_SLIDES_ANIMATE_END')
      state.interactiveSlidesAnimating = false
    },    

    MAIN_NAV_ANIMATE_START (state) {
      console.log('animations.module: MAIN_NAV_ANIMATE_START')
      EventBus.$emit('MAIN_NAV_ANIMATE_START')
      state.mainNavigationAnimating = true
    },

    MAIN_NAV_ANIMATE_END (state) {
      console.log('animations.module: MAIN_NAV_ANIMATE_END')
      EventBus.$emit('MAIN_NAV_ANIMATE_END')
      state.mainNavigationAnimating = false
    },

    SUB_NAV_ANIMATE_START (state) {
      console.log('animations.module: SUB_NAV_ANIMATE_START')
      EventBus.$emit('SUB_NAV_ANIMATE_START')
      state.subNavigationAnimating = true
    },

    SUB_NAV_ANIMATE_END (state) {
      console.log('animations.module: SUB_NAV_ANIMATE_END')
      EventBus.$emit('SUB_NAV_ANIMATE_END')
      state.subNavigationAnimating = false
    },    

    TAGS_ANIMATE_START (state) {
      console.log('animations.module: TAGS_ANIMATE_START')
      EventBus.$emit('TAGS_ANIMATE_START')
      state.tagsAnimating = true
    },

    TAGS_ANIMATE_END (state) {
      console.log('animations.module: TAGS_ANIMATE_END')
      EventBus.$emit('TAGS_ANIMATE_END')
      state.tagsAnimating = false
    },        
  }
}